import { versionController } from '../../../shared/scripts/EntryShared.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { ViewPopupLogin } from '../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { GuestPopupSource } from '../../../shared/scripts/analytics/sendGuestPopupAnalytic.ts';
import { StorageWrapper } from '../../../shared/scripts/StorageWrapper.ts';
import { UserSessionUtils } from '../../../shared/scripts/UserSessionUtils.ts';
import { DurationConverter, RandomUtils, TimeUtils } from '@colonist/utils';
import { AnalyticEventValue } from '../../../../shared/entity_datas/EntityDatas.ts';
import { showBecomeMemberDialog } from '../../../shared/scripts/ui_popup/showBecomeMemberDialog.ts';
import { UIEntryUrlParameterController } from '../../../shared/scripts/UIEntryUrlParameterController.ts';
export class UIPopupFunnelIncentiveController {
    static showMembershipIncentivePopup(accessGameFromLink) {
        if (accessGameFromLink) return;
        if (UIEntryUrlParameterController.suppressPopupsOnLoad == true) return;
        const lastMembershipIncentivePopupTime = StorageWrapper.getLastMembershipIncentivePopupTime();
        if (UIPopupFunnelIncentiveController.membershipIncentivePopupWasShownInLastTwentyFourHours(lastMembershipIncentivePopupTime)) return;
        const showGameplayPopup = UIUtilsEjsVariables.isUserOnDiscord || RandomUtils.randomBool();
        const analyticEventValue = UIUtilsEjsVariables.isUserOnDiscord ? AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral : AnalyticEventValue.PopupMembershipIncentiveSubscription;
        const type = showGameplayPopup ? 'gameplay' : 'basic';
        showBecomeMemberDialog(type, analyticEventValue);
        StorageWrapper.setLastMembershipIncentivePopupTime(new Date());
    }
    static membershipIncentivePopupWasShownInLastTwentyFourHours(lastMembershipIncentivePopupTime) {
        if (lastMembershipIncentivePopupTime == null) return false;
        const millisecondsSinceLastMembershipIncentivePopupTime = TimeUtils.millisecondsPassedSince(lastMembershipIncentivePopupTime.getTime());
        const shownWithinLastDay = millisecondsSinceLastMembershipIncentivePopupTime < DurationConverter.daysAsMilliseconds(1);
        return shownWithinLastDay;
    }
    static showPopup(accessGameFromLink) {
        if (versionController === null || versionController === void 0 ? void 0 : versionController.willShowPatchnoteThisSession) return;
        if (UIEntryUrlParameterController.suppressPopupsOnLoad == true) return;
        if (UserSessionUtils.canShowLoginPopup()) new ViewPopupLogin(false, undefined, {
            popupSource: GuestPopupSource.RoomEntryLogin
        });
        else if (UserSessionUtils.canShowSubscriptionPopup()) UIPopupFunnelIncentiveController.showMembershipIncentivePopup(accessGameFromLink);
    }
}
